/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */

/**
 * The configuration data for Expenses Analyzer pages
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @version 1.4.0
 * @since 1.1.0
 */

import { EBreadCrumbType } from '../../modules/breadCrumbs/breadCrumbsTypes';
import { EExpensesAnalyzerTypes } from '../../pages/PageExpensesAnalyzer/types/pageExpensesAnalyzerTypes';
import { IAppRouterConfiguration } from '../appRouterTypes';
import { RoutePath } from './routesConstants';

export interface IAnalyzerRouteConfiguration extends IAppRouterConfiguration {
    type: EExpensesAnalyzerTypes;
}

export const AnalyzerRouteConfiguration: IAnalyzerRouteConfiguration[] = [
    {
        breadCrumbs: [EBreadCrumbType.accounts],
        path: RoutePath.expensesAnalyzerAccount,
        type: EExpensesAnalyzerTypes.Account,
    },
    {
        breadCrumbs: [EBreadCrumbType.accounts, EBreadCrumbType.expensesAccounts],
        path: RoutePath.expensesAnalyzerAccountSubscribers,
        type: EExpensesAnalyzerTypes.AccountSubscribers,
    },
    {
        breadCrumbs: [EBreadCrumbType.accounts, EBreadCrumbType.accountId],
        path: RoutePath.expensesAnalyzerAccountId,
        type: EExpensesAnalyzerTypes.AccountSingle,
    },
    {
        breadCrumbs: [EBreadCrumbType.accounts, EBreadCrumbType.accountId, EBreadCrumbType.expensesAccountId],
        path: RoutePath.expensesAnalyzerAccountIdSubscribers,
        type: EExpensesAnalyzerTypes.AccountSingleSubscribers,
    },
    {
        breadCrumbs: [EBreadCrumbType.accounts, EBreadCrumbType.bills],
        path: RoutePath.expensesAnalyzerBillsAccounts,
        type: EExpensesAnalyzerTypes.BillsAccount,
    },
    {
        breadCrumbs: [EBreadCrumbType.accounts, EBreadCrumbType.accountId, EBreadCrumbType.billsAccountId],
        path: RoutePath.expensesAnalyzerBillsAccountId,
        type: EExpensesAnalyzerTypes.BillsAccountSingle,
    },
    {
        breadCrumbs: [EBreadCrumbType.accounts, EBreadCrumbType.bills, EBreadCrumbType.expensesBillsAccounts],
        path: RoutePath.expensesAnalyzerBillsAccountsSubscribers,
        type: EExpensesAnalyzerTypes.BillsAccountsSubscribers,
    },
    {
        breadCrumbs: [EBreadCrumbType.accounts, EBreadCrumbType.accountId, EBreadCrumbType.billsAccountId,
            EBreadCrumbType.expensesBillsAccountId],
        path: RoutePath.expensesAnalyzerBillsAccountIdSubscribers,
        type: EExpensesAnalyzerTypes.BillsAccountSingleSubscribers,
    },
    {
        breadCrumbs: [EBreadCrumbType.accounts, EBreadCrumbType.billsUnpaid],
        path: RoutePath.expensesAnalyzerBillsUnpaidAccounts,
        type: EExpensesAnalyzerTypes.BillsUnpaidAccount,
    },
    {
        breadCrumbs: [EBreadCrumbType.accounts, EBreadCrumbType.accountId, EBreadCrumbType.billsUnpaidAccountId],
        path: RoutePath.expensesAnalyzerBillsUnpaidAccountId,
        type: EExpensesAnalyzerTypes.BillsUnpaidAccountSingle,
    },
    {
        breadCrumbs: [EBreadCrumbType.accounts, EBreadCrumbType.billsUnpaid,
            EBreadCrumbType.expensesBillsUnpaidAccounts],
        path: RoutePath.expensesAnalyzerBillsUnpaidAccountsSubscribers,
        type: EExpensesAnalyzerTypes.BillsUnpaidAccountsSubscribers,
    },
    {
        breadCrumbs: [EBreadCrumbType.accounts, EBreadCrumbType.accountId, EBreadCrumbType.billsUnpaidAccountId,
            EBreadCrumbType.expensesBillsUnpaidAccountId],
        path: RoutePath.expensesAnalyzerBillsUnpaidAccountIdSubscribers,
        type: EExpensesAnalyzerTypes.BillsUnpaidAccountSingleSubscribers,
    },
    {
        breadCrumbs: [EBreadCrumbType.subscriberFixed],
        path: RoutePath.expensesAnalyzerSubscriberFixed,
        type: EExpensesAnalyzerTypes.SubscriberFixed,
    },
    {
        breadCrumbs: [EBreadCrumbType.subscriberMobile],
        path: RoutePath.expensesAnalyzerSubscriberMobile,
        type: EExpensesAnalyzerTypes.SubscriberMobile,
    },
];
